import React from 'react';
import { motion } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className,
  id,
  delay = 0
}: SectionProps) {
  return <section id={id} className={cn('py-14 px-5 md:px-6 relative overflow-hidden', className)} data-id="element-354">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      delay,
      ease: [0.25, 0.46, 0.45, 0.94]
    }} className="max-w-5xl mx-auto relative z-10" data-id="element-355">
        {children}
      </motion.div>
    </section>;
}